import useEnvironmentStore from "@/store/useEnvironmentStore";
import { capitalize } from "lodash";
import pluralize from "pluralize";

export enum MilkenWords {
  colleagues = "connection",
  department = "groups",
  interdepartmental = "intergroup",
}

type TMilkenWords = {
  capitalize?: boolean;
  plural?: boolean;
};

const useMilken = () => {
  const { env, module } = useEnvironmentStore();

  const isMilken = env === "ml";
  const isConferenceOrIsMilken = module === "conference" || isMilken;
  const milkenWordsConversion = (
    word: keyof typeof MilkenWords,
    config?: TMilkenWords,
  ) => {
    if (isMilken || module === "conference") {
      const baseWord = MilkenWords[word];
      if (config?.capitalize) {
        return pluralize(capitalize(baseWord), config?.plural ? 2 : 1);
      }
      return pluralize(baseWord, config?.plural ? 2 : 1);
    } else {
      return word;
    }
  };

  return {
    isMilken,
    milkenWordsConversion,
    isConferenceOrIsMilken,
  };
};

export default useMilken;
